module.exports = __webpack_public_path__ + "img/slide-27.933e5037.jpg";